import { QrCode, Store, MapPin } from "lucide-react";

const AnalyticsTab = ({ cardUsageAnalytics }) => {
  return (
    <div className="space-y-6">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-[#0B0F19] rounded-xl p-6 border border-[#D4AF37]/10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center">
              <QrCode className="w-5 h-5 text-[#D4AF37]" />
            </div>
            <div>
              <p className="text-white/50 text-sm">Total Scans (30 days)</p>
              <p className="text-2xl font-bold text-white">{cardUsageAnalytics?.total_scans || 0}</p>
            </div>
          </div>
        </div>
        <div className="bg-[#0B0F19] rounded-xl p-6 border border-[#D4AF37]/10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-[#047857]/10 flex items-center justify-center">
              <Store className="w-5 h-5 text-[#047857]" />
            </div>
            <div>
              <p className="text-white/50 text-sm">Active Businesses</p>
              <p className="text-2xl font-bold text-white">{cardUsageAnalytics?.by_business?.length || 0}</p>
            </div>
          </div>
        </div>
        <div className="bg-[#0B0F19] rounded-xl p-6 border border-[#D4AF37]/10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center">
              <MapPin className="w-5 h-5 text-blue-400" />
            </div>
            <div>
              <p className="text-white/50 text-sm">Top Location</p>
              <p className="text-2xl font-bold text-white capitalize">
                {cardUsageAnalytics?.by_location?.[0]?.location?.replace(/_/g, ' ') || 'N/A'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Card Usage by Business */}
      <div className="bg-[#0B0F19] rounded-xl border border-[#D4AF37]/10 overflow-hidden">
        <div className="p-4 border-b border-white/5">
          <h3 className="text-lg font-semibold text-white flex items-center gap-2">
            <Store className="w-5 h-5 text-[#D4AF37]" />
            Card Usage by Business
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-white/5">
              <tr>
                <th className="p-4 text-left text-white/70 font-medium">Business</th>
                <th className="p-4 text-left text-white/70 font-medium">Location</th>
                <th className="p-4 text-left text-white/70 font-medium">Total Scans</th>
                <th className="p-4 text-left text-white/70 font-medium">Unique Members</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {cardUsageAnalytics?.by_business?.map((biz, idx) => (
                <tr key={idx} className="hover:bg-white/5">
                  <td className="p-4 text-white">{biz.business_name}</td>
                  <td className="p-4 text-white/50 capitalize">{biz.sub_location?.replace(/_/g, ' ') || 'N/A'}</td>
                  <td className="p-4">
                    <span className="bg-[#D4AF37]/20 text-[#D4AF37] px-3 py-1 rounded-full text-sm font-medium">
                      {biz.total_scans}
                    </span>
                  </td>
                  <td className="p-4 text-white/70">{biz.unique_members}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {(!cardUsageAnalytics?.by_business || cardUsageAnalytics.by_business.length === 0) && (
            <p className="p-8 text-center text-white/40">No card usage data yet. Scans will appear here when businesses validate membership cards.</p>
          )}
        </div>
      </div>

      {/* Card Usage by Location */}
      <div className="bg-[#0B0F19] rounded-xl border border-[#D4AF37]/10 overflow-hidden">
        <div className="p-4 border-b border-white/5">
          <h3 className="text-lg font-semibold text-white flex items-center gap-2">
            <MapPin className="w-5 h-5 text-[#D4AF37]" />
            Card Usage by Location
          </h3>
        </div>
        <div className="p-4 grid grid-cols-2 md:grid-cols-4 gap-4">
          {cardUsageAnalytics?.by_location?.map((loc, idx) => (
            <div key={idx} className="bg-white/5 rounded-lg p-4 text-center">
              <p className="text-white font-medium capitalize">{loc.location?.replace(/_/g, ' ')}</p>
              <p className="text-2xl font-bold text-[#D4AF37] mt-1">{loc.total_scans}</p>
              <p className="text-white/40 text-xs">scans</p>
            </div>
          ))}
          {(!cardUsageAnalytics?.by_location || cardUsageAnalytics.by_location.length === 0) && (
            <p className="col-span-full text-center text-white/40 py-4">No location data yet</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsTab;
